module.exports = "/_next/static/images/offer-faded-c9b82f87f2cc6f95748cd91c9e5ac778.svg";